/**
 * GeoBlocked Page
 * Shown when a user's location is outside the allowed countries.
 * Provides a clear message and a link to report issues.
 */

import React from 'react';

const GeoBlocked: React.FC = () => {
  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Icon */}
        <div className="mx-auto w-20 h-20 bg-cyan-100 rounded-full flex items-center justify-center mb-6">
          <svg
            className="w-10 h-10 text-cyan-700"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
            />
          </svg>
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-semibold text-stone-900 font-['Work_Sans'] mb-3">
          Service Not Available in Your Region
        </h1>

        {/* Message */}
        <p className="text-stone-600 text-base font-['Work_Sans'] mb-6 leading-relaxed">
          End of an Era is currently only available in the{' '}
          <span className="font-medium text-stone-800">United States</span>,{' '}
          <span className="font-medium text-stone-800">United Kingdom</span>,{' '}
          <span className="font-medium text-stone-800">Canada</span>, and{' '}
          <span className="font-medium text-stone-800">Australia</span>.
        </p>

        <p className="text-stone-500 text-sm font-['Work_Sans'] mb-8 leading-relaxed">
          We are working to expand to more regions in the future. If you believe
          you are seeing this message in error, please contact our support team.
        </p>

        {/* Contact Button */}
        <a
          href="https://www.endofanera.ai/contact"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-cyan-700 text-white rounded-lg hover:bg-cyan-800 transition-colors font-medium font-['Work_Sans']"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          Contact Support
        </a>

        {/* Footer note */}
        <p className="mt-10 text-stone-400 text-xs font-['Work_Sans']">
          End of an Era &mdash; Secure Estate Planning
        </p>
      </div>
    </div>
  );
};

export default GeoBlocked;
